<template>
  <div style="padding-bottom: 44px;">
    <div class="train">
      <div class="cate">
        <div class="cate_police">
          <div class="cate-all">调训类型：</div>
          <div class="subject">
            <span
              v-for="(item, index) in typeList"
              :key="index"
              :class="{heightlight : typeindex==index}"
              @click="btnTypeindex(index,item)"
            >{{ item.name }}</span>
          </div>
        </div>

        <div class="cate_police">
          <div class="cate-all">培训等级：</div>
          <div class="subject">
            <span
              v-for="(item, index) in bytypeList"
              :key="index"
              :class="{heightlight : bytypeindex==index}"
              @click="btnTypeIdindex(index,item)"
            >{{ item.name }}</span>
          </div>
        </div>

        <div class="cate_police">
          <div class="cate-all">调训警种：</div>
          <div ref="jzlistobjerfive" :class='["subject", jzlist&&putaway ? "hiddenlist" : ""]'>
            <span
              v-for="(item, index) in policeClassification"
              :key="index"
              @click="policeClassArea(index,item)"
              :class="{heightlight : policeClassindex==index}"
            >{{ item.name }}</span>
            <div v-if="jzlist&&putaway" class="showlist" @click="()=>{putaway = !putaway}">
              <span>更多</span>
              <i class="el-icon-caret-bottom"></i>
            </div>
            <div v-if="jzlist&&!putaway" class="showlist" @click="()=>{putaway = !putaway}">
              <span>收起</span>
              <i class="el-icon-caret-top"></i>
            </div>
          </div>
        </div>

        <div style="border-bottom:1px solid #dcdfe6;" class="cate_police">
          <div class="cate-all">地市/州 ：</div>
          <div :class='["subject", cityers&&cityputaway ? "hiddenlist" : ""]' ref="getheight">
            <span
              v-for="(item, index) in cityList"
              :key="index"
              :class="{heightlight : cityIndex==index}"
              @click="selectCity(index,item)"
            >{{ item.name }}</span>
            <div v-if="cityers&&cityputaway" class="showlist" @click="()=>{cityputaway = !cityputaway}">
              <span>更多</span>
              <i class="el-icon-caret-bottom"></i>
            </div>
            <div v-if="cityers&&!cityputaway" class="showlist" @click="()=>{cityputaway = !cityputaway}">
              <span>收起</span>
              <i class="el-icon-caret-top"></i>
            </div>
          </div>
        </div>
        
      </div>

      <div class="box">
        <div class="boxleft">
          <div class="searchModel" style="display:flex;align-items: center;">
            <div class="subject" style="padding-right: 30px;">
              <span
                v-for="(item, index) in newList"
                :key="index"
                style="margin-bottom: 0px;"
                :class="{heightlight : newIndex==index}"
                @click="policeNew(index,item)"
              >{{item.name}}</span>
            </div>
            <el-input
              size="large"
              placeholder="请输入搜索内容"
              @change="selectList"
              v-model="listQuery.title"
              class="input-with-select"
              style="width:287px;height:40px;font-size: 16px;border-radius:4px;flex-shrink: 0;"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="selectList"
                style="background:#51565C;border-radius:0px;height:100%;color:white;font-size:16px;"
              ></el-button>
            </el-input>
          </div>
          <trainBoxleft ref="trainBoxleftRef" :listQuery="listQuery"></trainBoxleft>
        </div>
        <div class="boxright">
          <trainBoxright></trainBoxright>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import trainBoxleft from './trainBox/trainBoxleft';
import trainBoxright from './trainBox/trainBoxright';
import * as trainapi from '@/api/train/index';
import * as teacherInfo from '@/api/teacher/teacherInfo';
import * as publics from '@/api/public';
import * as Dept from '@/api/pmi/dept';
import linecom from '@/components/linecom/index';
export default {
  components: {
    trainBoxleft,
    trainBoxright,
    linecom,
  },
  data() {
    return {
      setHeight: 0,
      height: 0,
      photocom: [],
      baseData: [],
      newList: [
        { subType: null, name: '全部' },
        { subType: 0, name: '未开始' },
        { subType: 1, name: '进行中' },
        { subType: 2, name: '已结束' },
      ],
      newIndex: 0,
      cityList: [{ name: '全部', id: 0 }],
      cityIndex: 0,
      typeList: [{ name: '全部', id: 0 }],
      bytypeList: [{ name: '全部', id: 0 }],
      bytypeindex: 0,
      typeindex: 0,
      policeClassification: [{ name: '全部', id: 0 }], //全部警种
      policeClassindex: 0,
      examTypeindex: 0, //高亮默认为全部
      nowYear: new Date(),
      subTypeList: [
        { subType: 0, name: '全' },
        { subType: 1, name: '2021' },
        { subType: 2, name: '2020' },
        { subType: 3, name: '2019' },
      ],
      listQuery: {
          unitId: JSON.parse(this.$store.state.User.infos).unitId,
        subType: null,
        JzDicId: null,
        CateDicId: null,
        title: '',
        PassStatus: 1,
        page: 1,
        limit: 20,
        IsChild: true,
        SignStatus: null,
        classLevel: null,
      },
      listQuery2: {
        namespaceId: null,
        page: 1,
        limit: 50,
      },
      namespaceIdd: 9,
      jzlist: false,
      putaway: true,
      cityers: false,
      cityputaway: true,
    };
  },
  created() {
    this.nowYear = this.nowYear.getFullYear();
    for (let index = 0; index < this.subTypeList.length; index++) {
      this.subTypeList[1].name = this.nowYear;
      this.subTypeList[2].name = this.nowYear - 1;
      this.subTypeList[3].name = this.nowYear - 2;
    }
    this.getbaseList();
    this.getPmiDictionary(1, this.policeClassification); //获取警种数组
    this.getDishi();
    this.getPmiDictionary(53, this.typeList); //获取类别数组
    this.getGetByTypeId();
  },
  methods: {
    // 鼠标移入加入class
    changeActive($event) {
      this.setHeight = this.height;
    },
    removeActive($event) {
      this.setHeight = 0;
    },
    // 鼠标经过获取高度
    getAver() {
      console.log(this.$refs.getheight.scrollHeight);
      this.height = this.$refs.getheight.offsetHeight;
    },
    selectList() {
      this.$refs.trainBoxleftRef.getList();
    },
    policeClassArea(index, item) {
      this.policeClassindex = index;
      if (item.id == 0) {
        this.listQuery.JzDicId = null;
      } else {
        this.listQuery.JzDicId = item.id;
      }
      this.$refs.trainBoxleftRef.getList();
    },
    examType(index, item) {
      this.examTypeindex = index;
      if (item.subType == 0) {
        this.listQuery.subType = null;
      } else {
        this.listQuery.subType = item.subType;
      }
      this.$refs.trainBoxleftRef.getList();
    },
    getPmiDictionary(index, arr) {
      this.listQuery2.namespaceId = index;
      teacherInfo
        .getPmiDic(this.listQuery2)
        .then((response) => {
         
          response.result.forEach((e) => {
            arr.push({ name: e.name, id: e.id });
          });
          this.getAver();
          this.$nextTick(()=>{
            if(this.$refs.jzlistobjerfive.clientHeight > 42){
              this.jzlist = true
            }
          })
        })
        .catch(() => {});
    },

    // 获取培训等级
    getGetByTypeId() {
      let data = {
        namespaceId: this.namespaceIdd,
      };
      publics.getList(data).then((response) => {
        // let arr = [];
        response.result.forEach((e) => {
          this.bytypeList.push({ name: e.name, id: e.id });
        });
        // this.bytypeList = arr;
        this.getAver();
      });
    },

    //查询类别
    btnTypeindex(index, item) {
      this.typeindex = index;
      if (item.id == 0) {
        this.listQuery.CateDicId = null;
      } else {
        this.listQuery.CateDicId = item.id;
      }
      this.$refs.trainBoxleftRef.getList();
    },
    // 培训等级
    btnTypeIdindex(index, item) {
      this.bytypeindex = index;
      if (item.id == 0) {
        this.listQuery.classLevel = null;
      } else {
        this.listQuery.classLevel = item.id;
      }
      this.$refs.trainBoxleftRef.getList();
    },

    //查询地市
    selectCity(index, item) {
      this.cityIndex = index;

      if (item.id == 0) {
        this.listQuery.deptid = null;
      } else {
        this.listQuery.deptid = item.id;
      }
      this.$refs.trainBoxleftRef.getList();
    },
    //获取地市
    getDishi() {
      Dept.getCity().then((res) => {
        res.result.forEach((e) => {
          this.cityList.push({ name: e.name, id: e.id });
        });
        this.$nextTick(()=>{
          if(this.$refs.getheight.clientHeight > 42){
              this.cityers = true
            }
        })
      });
    },
    //查询新热
    policeNew(index, item) {
      this.newIndex = index;
      this.listQuery.SignStatus = item.subType;
      this.$refs.trainBoxleftRef.getList();
    },
    getbaseList() {
      trainapi.GetLoadTrainBase(this.listQuery).then((res) => {
        console.log(res);
        this.baseData = res.data;
        this.forphoto(this.baseData);
      });
    },
    forphoto(list) {
      // list是要进行拆分的数组数组
      //    思路：将整组图片数据进行拆分，变成二维数组，一个数组里面放八个数据，多的放下一个数组
      const listResult = []; // 最终返回的二维数组
      for (let i = 0; i < Math.ceil(list.length / 8); i++) {
        listResult[i] = [];
        // 最终获得多少个二维数组
        for (let j = 0; j < 8; j++) {
          // 如果是最后一个板块
          if (i === Math.ceil(list.length / 8) - 1) {
            if (Math.ceil(list.length % 8) !== 0) {
              // 只有最后一个板块的数据在余数以内的才赋值
              if (j < Math.ceil(list.length % 8)) {
                listResult[i][j] = list[i * 8 + j];
              }
            } else {
              // 如果刚好整整一个板块，则全部附上值
              listResult[i][j] = list[i * 8 + j];
            }
          } else {
            listResult[i][j] = list[i * 8 + j];
          }
        }
      }
      // return listResult;
      this.photocom = listResult;
      console.log(this.photocom);
    },
    trainBase(Id) {
      this.$router.push({
        path: '/train/trainBase',
        query: {
          id: Id,
        },
      });
    },
  },
};
</script>

<style scoped>
.train {
  width: 1200px;
  margin: 0 auto;
}
.header {
  margin-top: 30px;
  text-align: center;
  line-height: 90px;
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  width: 1250px;
  height: 110px;
  background-image: url('../../assets/train/u756.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.imageList {
  padding: 10px;
  width: 1230px;
  height: 480px;
  background-color: #fff;
}
.zoumadeng {
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}
.imageList /deep/.el-carousel__container {
  height: 450px;
}
.imageList /deep/.el-carousel__button {
  height: 15px;
  width: 15px;
  background-color: rgb(15, 91, 189) !important;
  border-radius: 50%;
}
.box {
  margin: 0 auto;
  width: 1200px;
  min-height: 980px;
  margin-top: 14px;
  display: flex;
  justify-content: space-between;
  padding: 21px 14px 0px 14px;
  box-sizing: border-box;
  background: linear-gradient(to bottom, #97CAF4 0%,#fff 300px,#fff 100%);
  border-radius: 4px;
}
.boxleft {
  position: relative;
  width: 846px;
  height: 930px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.05);
}
.searchModel{
  position: absolute;
  right: 10px;
  top: 14px;
}
.boxright {
  width: 303px;
  height: 930px;
  background-color: #fff;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}
/* 头部搜索 */
.cate {
  box-sizing: border-box;
  width: 100%;
  background: #ffffff;
  margin: 0 auto;
  margin-top: 14px;
  border-radius: 4px;
  padding: 44px 28px 27px 35px;
}

.cate_police {
  display: flex;
  font-size: 16px;
}

.cate_police + .cate_police{
  margin-top: 12px;
}

.cate-all{
  width: 76px;
  font-size: 14px;
  line-height: 21px;
  margin-right: 10px;
}
.subject {
  position: relative;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  padding-right: 80px;
  display: flex;
  flex-wrap: wrap;
}
.subject > span {
  cursor: pointer;
  font-size: 14px;
  line-height: 22px;
  height: 22px;
  padding: 0px 10px;
  color: #000;
  border: 1px solid #fff;
  border-radius: 4px;
  margin-right: 10px;
  margin-bottom: 20px;
}
.subject > span:hover {
  border: 1px solid #649FED;
  color: #649FED;
  border-radius: 4px;
}

/deep/.input-with-select input{
  border-radius: 4px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
/deep/.input-with-select .el-input-group__append{
  border-color: #51565C;
}

/* 头部搜索 */
/* 高亮 */
.heightlight {
  background-color: #649FED !important;
  color: #f8fafc !important;
}
.cityst {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
  justify-content: space-between;
  padding-bottom: 40px;
}
.selectTxt {
  width: 280px;
}

.subject >.showlist{
  position:absolute;
  z-index: 3;
  right: 5px;
  top: 0px;
  padding-left: 10px;
  cursor: pointer;
  height: 22px;
  line-height: 22px;
  font-size: 14px;
  color: #4D515A;
}
.hiddenlist{
  height: 42px;
}
</style>